var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{style:({'cursor': 'pointer'}),on:{"click":_vm.handleItemClick}},[_c('td',[_vm._v(_vm._s(_vm.item.code))]),_c('td',[_vm._v(_vm._s(_vm._f("NoEmpty")(_vm.item.title)))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.item.price)))])])}
var staticRenderFns = []

export { render, staticRenderFns }